export default "__VITE_ASSET__CiRcM2gq__"